<template>
  <Head title="Password Dimenticata" />
  <div class="flex items-center justify-center p-6 min-h-screen bg-indigo-800">
    <div class="w-full max-w-md">
      <logo class="block mx-auto w-full max-w-xs fill-white" height="50" />
      <form class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden" @submit.prevent="submit">
        <div class="px-10 py-12">
          <h1 class="text-center text-2xl font-bold">Recupera Password</h1>
          <p class="text-center text-sm text-gray-600 mt-2">
            Inserisci il tuo indirizzo email e ti invieremo un link per reimpostare la password.
          </p>
          <div class="mt-6 mx-auto w-24 border-b-2" />

          <div v-if="status" class="mt-6 p-4 bg-green-100 border border-green-400 text-green-700 rounded">
            {{ status }}
          </div>

          <text-input
            v-model="form.email"
            :error="form.errors.email"
            class="mt-10"
            label="Email"
            type="email"
            autofocus
            autocapitalize="off"
          />
        </div>
        <div class="flex items-center justify-between px-10 py-4 bg-gray-100 border-t border-gray-100">
          <Link href="/login" class="text-sm text-indigo-600 hover:text-indigo-800 underline">
            Torna al Login
          </Link>
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">
            Invia Link
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import LoadingButton from "@/Pages/Dashboard/Shared/LoadingButton";
import Logo from "@/Pages/Dashboard/Shared/Logo";
import TextInput from "@/Pages/Dashboard/Shared/TextInput";
import { Head, Link } from "@inertiajs/inertia-vue3";

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    Logo,
    TextInput,
  },
  props: {
    status: String,
  },
  data() {
    return {
      form: this.$inertia.form({
        email: "",
      }),
    };
  },
  methods: {
    submit() {
      this.form.post("/forgot-password");
    },
  },
};
</script>
